import { render, staticRenderFns } from "./TkChangePerson.vue?vue&type=template&id=2935ae71&scoped=true&"
import script from "./TkChangePerson.vue?vue&type=script&lang=js&"
export * from "./TkChangePerson.vue?vue&type=script&lang=js&"
import style0 from "./TkChangePerson.vue?vue&type=style&index=0&id=2935ae71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935ae71",
  null
  
)

export default component.exports